// @flow

import { Map, List, fromJS } from 'immutable'

export function accountSetups(state: List<any> = List([]), action: Object) {
	switch (action.type) {
		case 'ACCOUNT_SETUPS_FETCH_SUCCESS':
			return fromJS(action.accountSetups)
		default:
			return state
	}
}

export function accountSetupsPagination(state: Map<string, any> = Map({}), action: Object) {
	switch (action.type) {
		case 'ACCOUNT_SETUPS_FETCH_PAGINATION_SUCCESS':
			return fromJS(action.pagination)
		default:
			return state
	}
}

const defaultFilterData = Map({
	page: 1,
	per_page: 10
})

export function accountSetupsFilterData(state: Map<string, any> = defaultFilterData, action: Object) {
	switch (action.type) {
		case 'ACCOUNT_SETUPS_ADD_FILTER_PAGE_NUMBER_SUCCESS':
			return state.set('page', action.page)
		case 'ACCOUNT_SETUPS_ADD_FILTER_PER_PAGE_SUCCESS':
			return state.set('per_page', action.per_page)
		default:
			return state
	}
}
